module.exports = __webpack_public_path__ + "img/5.ac22c3e4.jpg";